import { createContext, useContext, useState, useEffect, useRef, useCallback } from "react";


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        try {
            const storedUser = localStorage.getItem("user");
            return storedUser ? JSON.parse(storedUser) : null;
        } catch (error) {
            console.error("Error parsing user data:", error);
            return null;
        }
    });

    const logoutTimerRef = useRef(null);

    const resetTimer = useCallback(() => {
        console.log("Resetting logout timer");
        if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
       logoutTimerRef.current = setTimeout(() => {
            console.log("Auto logout triggered");
            logout();
            }, 30 * 60 * 1000); // 1 minute for testing

    }, []);

    useEffect(() => {
        if (!user) return;
        const activityEvents = ["mousemove", "keydown", "scroll", "click"];
        activityEvents.forEach((event) => window.addEventListener(event, resetTimer));
        resetTimer();

        return () => {
            if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
            activityEvents.forEach((event) => window.removeEventListener(event, resetTimer));
        };
    }, [user, resetTimer]);

    useEffect(() => {
        if (user) {
            localStorage.setItem("user", JSON.stringify(user));
        }
    }, [user]);

    const login = (userData) => {
        setUser(userData);
    };

    const logout = () => {
        setUser(null);
        localStorage.clear();
        if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
        window.location.href = "/";
    };

    const isAuthenticated = !!user;

    const hasRole = (role) => {
        return user?.role === role; // assuming user.role is a string like 'admin', 'superuser', or 'user'
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, isAuthenticated, hasRole }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);